import { ReactNode } from 'react';
import type { FC } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material';

declare interface Props {
  open: boolean;
  title: string;
  centerAlignTitle?: boolean;
  hasCancel?: boolean;
  onOK?: () => void;
  onCancel?: () => void;
  children: ReactNode;
  okButtonText?: string;
  hasBtnDivider?: boolean;
  sx?: any;
  isLoading?: boolean;
}

const ModalWindow: FC<React.PropsWithChildren<Props>> = ({
  open,
  onOK,
  onCancel,
  children,
  title,
  okButtonText,
  hasBtnDivider,
  hasCancel = true,
  centerAlignTitle,
  sx,
  isLoading,
}) => {
  return (
    <Dialog open={open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" sx={sx}>
      <DialogTitle id="alert-dialog-title" sx={centerAlignTitle ? { textAlign: 'center' } : null}>
        {title}
      </DialogTitle>
      <DialogContent>{children}</DialogContent>

      {hasBtnDivider && (
        <>
          <br /> <Divider />
        </>
      )}

      <DialogActions>
        {hasCancel && (
          <Button onClick={onCancel} disabled={isLoading}>
            Cancel
          </Button>
        )}
        <Button onClick={onOK} autoFocus disabled={isLoading}>
          {okButtonText || 'OK'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalWindow;
